import React from 'react'
import { Lozenge } from '@manychat/manyui'

import { SubscriptionElementProps } from './types'

export const SubscriptionElement = ({ label, lozenge }: SubscriptionElementProps) => {
  return (
    <div className="p-y-xxs p-x-xs bg-default rounded d-inline-flex align-center">
      <label className="font-medium">{label}</label>
      {lozenge && <Lozenge className="m-x-xxs" type={lozenge} />}
    </div>
  )
}
